module.exports = __webpack_public_path__ + "static/media/done.36740fbe.png";